import { useState } from 'react';
import { useLocation } from 'react-router';

export const useLeftNav = () => {
  const location = useLocation();
  const [isShown, show] = useState<boolean>(false);

  return {
    location,
    isShown,
    toggle: () => show(!isShown),
    hide: () => show(false),
  };
};
